/**
 * 政策纯逻辑（无 React / 无 DB / 无 DOM 字符串）
 * 结构：省份行 + 卡片网格；卡片与区块已改为真正的 JSX 组件。
 */
import type {PolicyItem, PolicyProvinceCount} from '@/common/interface/policy';

/** 省份行第一个 tab：展示全部政策 */
export const POLICY_ALL_TAB = '全国';

/** 国家级政策固定排在「全国」之后、各省之前 */
export const POLICY_NATIONAL = '国家级';

/** 近 3 个月内发布的政策打「最新」标签 */
export const LATEST_MONTHS = 3;

/** 政策是否在近 LATEST_MONTHS 个月内发布 */
export function isLatest(date: string, now = new Date()): boolean {
    const t = Date.parse(date);
    if (Number.isNaN(t)) return false;
    const from = new Date(now.getTime());
    from.setMonth(from.getMonth() - LATEST_MONTHS);
    return t >= from.getTime() && t <= now.getTime();
}

/** 按发布时间倒序（同日期按标题稳定排序） */
export function sortByDateDesc(list: PolicyItem[]): PolicyItem[] {
    return [...list].sort((a, b) => (
        a.date === b.date ? a.title.localeCompare(b.title, 'zh-Hans-CN') : (a.date < b.date ? 1 : -1)
    ));
}

/** 省份分组计数：国家级置顶，其余按政策条数倒序 */
export function provinceCounts(list: PolicyItem[]): PolicyProvinceCount[] {
    const map = new Map<string, number>();
    list.forEach((p) => {
        if (p.province) map.set(p.province, (map.get(p.province) || 0) + 1);
    });
    return [...map.entries()]
        .map(([province, count]) => ({province, count}))
        .sort((a, b) => {
            if (a.province === POLICY_NATIONAL) return -1;
            if (b.province === POLICY_NATIONAL) return 1;
            return (b.count - a.count) || a.province.localeCompare(b.province, 'zh-Hans-CN');
        });
}
